import { FoldedCollection, Result } from '@coveo/headless';
import { ResultLink } from '../ResultLink';
import { HighlightedText } from '../HighlightedText';
import { Grid } from '@mui/material';
import { Quickview } from '../QuickView';
import { PersonalizedFieldNames } from 'Feature/Coveo/Models/CoveoModels';
import { getCoveoFieldNameByString } from 'Feature/Coveo/Mappers/CoveoFieldMapper';
import { Badge } from '@lmig/lmds-react-badge';
import { useUserData } from 'Foundation/User/UserContext';

export interface IPageResultsProps {
  collection: FoldedCollection;
}
export function ProductGuideResults({ collection }: IPageResultsProps) {
  const { userData } = useUserData();
  function getDate(result: Result, fieldName: string) {
    if (result.raw.hasOwnProperty(fieldName)) {
      const date: Date = new Date(result.raw[fieldName] as string);
      return date.toLocaleDateString();
    }
    return '';
  }

  function getArchived(result: Result): boolean {
    let fieldName = getCoveoFieldNameByString(PersonalizedFieldNames.archived)!.coveoFieldName;
    if (result.raw.hasOwnProperty(fieldName)) {
      return result.raw[fieldName] === 1;
    }
    return false;
  }

  function getAudience(result: Result) {
    let fieldName = getCoveoFieldNameByString(PersonalizedFieldNames.usertype)!.coveoFieldName;
    if (result.raw.hasOwnProperty(fieldName)) {
      const audience: string[] = result.raw[fieldName] as string[];
      if (audience.find((x) => x === 'Agent')) return 'Agents';
      else if (audience.length === 1 && audience[0] === 'Employee') return 'Employees';
    }
    return undefined;
  }

  function renderSubText(result: Result) {
    let effectiveDate = getCoveoFieldNameByString(PersonalizedFieldNames.effectivedate)!.coveoFieldName;
    //let hasThreeFields: boolean = userData && !userData.isAgent() && !getArchived(result);
    return (
      <Grid container className="result-date caption">
        {!getArchived(result) && <Grid size={{ xs: 6, sm: 4 }}>{'Modified Date: ' + getDate(result, 'date')}</Grid>}
        <Grid size={{ xs: 6, sm: 4 }}>{'Effective Date: ' + getDate(result, effectiveDate)}</Grid>
        {userData && !userData.isAgent() && <Grid size={{ xs: 6, sm: 4 }}>{'Audience: ' + getAudience(result)}</Grid>}
      </Grid>
    );
  }

  function displayExcerpt(result: Result) {
    return <HighlightedText value={result.excerpt} highlights={result.excerptHighlights} />;
  }

  return (
    <article className="result-folding-result">
      <div className="result-folding-title">
        <ResultLink result={collection.result} target="_blank">
          <HighlightedText value={collection.result.title} highlights={collection.result.titleHighlights} />
        </ResultLink>
        {getArchived(collection.result) && <Badge highlightType="caution">Archived</Badge>}
        <Quickview result={collection.result} modalClass="xlarge" />
      </div>
      <div className="result-folding-excerpts caption">
        <ul>
          <li>
            <article>
              <span>{displayExcerpt(collection.result)}</span>
            </article>
          </li>
        </ul>
      </div>
      {renderSubText(collection.result)}
    </article>
  );
}
